import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=58c3bff3&scoped=true&"
import script from "./countries.vue?vue&type=script&lang=js&"
export * from "./countries.vue?vue&type=script&lang=js&"
import style0 from "./countries.vue?vue&type=style&index=0&id=58c3bff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c3bff3",
  null
  
)

export default component.exports